import { Controller } from '@hotwired/stimulus';

export default class ProgramsFilterPillsController extends Controller {
  static targets = ['pillsSection', 'filter'];

  connect () {
    this.updateAllPills();
  }

  updateAllPills () {
    this.pillsSectionTarget.innerHTML = '';

    this.filterTargets.forEach((filter) => {
      const pillText = filter.nextElementSibling.innerHTML;

      if (pillText && filter.checked) this.createPill(pillText, filter);
    });
  }

  updateFilterPill (event) {
    const filter = event.target;
    if (filter.checked) {
      const pillText = filter.nextElementSibling.innerHTML;

      if (pillText) this.createPill(pillText, filter);
    } else {
      this.deletePill(filter);
    }
  }

  clearAllPills () {
    this.pillsSectionTarget.innerHTML = '';
  }

  clearFiltersPills (event) {
    const filterId = event.target.dataset.filter;

    this.filterTargets.filter(filter => filter.name === filterId).forEach((filter) => {
      this.deletePill(filter);
    });
  }

  createPill (text, targetElement) {
    const span = document.createElement('span');
    span.innerHTML = text;
    span.classList.add('filters__pill');

    const button = document.createElement('button');
    button.innerHTML = '&times;';
    button.classList.add('filters__clear');
    button.setAttribute('data-action', 'university-portal--programs-filter#pillSelectChange');
    button.setAttribute('data-filter-id', targetElement.id);

    span.appendChild(button);
    this.pillsSectionTarget.appendChild(span);
  }

  deletePill (targetElement) {
    const pill = Array.from(this.pillsSectionTarget.children)
      .find(item => item.lastChild.dataset.filterId === targetElement.id);

    if (pill) pill.remove();
  }
}
